<template>
  <div :class="['main-header-content',
  {'is-active-visible' : isActiveVisible}]">
    <a :class="['scrollactive-item', {'is-not-active': item.class !== $activeBlock}]"
       v-for="item in menuInfo"
       :data-section-selector="getBlock(item)"
       :key="item.id"
       @click.prevent="scrollTo(item)">
      {{ item.id }}
      <line-block v-if="activeIndex === item.id
                  && isActiveVisible"
                  :size="'big'"/>
      <main-paragraph :color="'purple-grey'">
        {{ item.text }}
      </main-paragraph>
    </a>
  </div>
</template>

<script>
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import LineBlock from "@/components/shared/LineBlock.vue";
import {mapState} from "vuex";

export default {
  name: "MenuItem",
  components: {LineBlock, MainParagraph},
  props: {
    isActiveVisible: {
      type: Boolean,
      default: false
    },
    menuInfo: {
      type: Array,
      required: true
    },
    activeIndex: {
      type: Number
    }
  },
  computed: {
    ...mapState(['$activeBlock'])
  },
  methods: {
    scrollTo(item) {
      this.$emit('scrollTo', item)
    },
    onItemChanged(event, currentItem) {
      console.log(currentItem)
    },

    getBlock(item) {
      return `#${item.rout}`;
    },

  }
}
</script>

<style scoped lang="scss">
.main-header-content {
  align-items: center;
  position: relative;
  display: flex;
  flex-direction: row;

  &.is-active-visible {
    transition: all .3s ease;
    flex-direction: column;
    align-items: flex-start;

    .scrollactive-item {
      display: flex;
      flex-direction: row;
      align-items: center;

      &.is-not-active {
        column-gap: 0;
        transition: all .3s ease;
        .line-block-container {
          min-width: 0;
        }
        .text-content {
          opacity: .6;
          &:hover {
            opacity: 1;
          }
        }
      }

      .line-block-container {
        transition: all .3s ease;
      }

      .text-content {
        transition: all .3s ease;
        color: var(--color-white) !important;
        font-weight: 500;
      }
    }
  }
}

.text-content {
  white-space: nowrap;
  cursor: pointer;
  transition: opacity .6s ease;

  &:hover {
    opacity: .5;
  }
}


.scrollactive-item {
  transition: transform 0.3s ease;
  position: relative;
}



@media (max-width: 3024px){
  .main-header-content {
    column-gap: 60px;


    &.is-active-visible {
      row-gap: 60px;

      .scrollactive-item {
        column-gap: 40px;


        .text-content {
          font-size: 52px;
        }
      }
    }
  }
}

@media (max-width: 1920px) {
  .main-header-content {
    column-gap: 40px;


    &.is-active-visible {
      row-gap: 52px;

      .scrollactive-item {
        column-gap: 30px;


        .text-content {
          font-size: 48px;
        }
      }
    }
  }
}
@media (max-width: 1600px) {
  .main-header-content {
    &.is-active-visible {
      row-gap: 40px;

      .scrollactive-item {
        column-gap: 24px;
        .text-content {
          font-size: 32px;
        }
      }
    }
  }
}
@media (max-height: 800px) {
  .main-header-content {
    &.is-active-visible {
      .scrollactive-item {
        column-gap: 18px;
        .text-content {
          font-size: 28px;
        }
      }
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .main-header-content {
    &.is-active-visible {
      row-gap: 40px;

      .scrollactive-item {
        column-gap: 24px;
        .text-content {
          font-size: 32px;
        }
      }
    }
  }

}

@media (max-width: 1133px) {
  .main-header-content {
    &.is-active-visible {
      .scrollactive-item {
        column-gap: 18px;
        .text-content {
          font-size: 28px;
        }
      }
    }
  }

}
@media (max-width: 769px) {
  .main-header-content {
    &.is-active-visible {
      .scrollactive-item {
        column-gap: 18px;
        .text-content {
          font-size: 24px;
        }
      }
    }
  }
  //iPhone 14
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  .main-header-content {
    &.is-active-visible {
      .scrollactive-item {
        .text-content {
          font-size: 28px;
        }
      }
    }
  }
}

@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  .main-header-content {
    &.is-active-visible {
      .scrollactive-item {
        column-gap: 12px;
        .text-content {
          font-size: 20px;
        }
      }
    }
  }
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {
  .main-header-content {
    column-gap: 120px;

    &.is-active-visible {
      row-gap: 100px;

      .scrollactive-item {
        column-gap: 60px;


        .text-content {
          font-size: 98px;
        }
      }
    }
  }
}
</style>
